<mbs-modal
  [title]="baseModal().data.title"
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true"
  [loading]="loadingReleaseDate()"
  #modal>
  <div modal-body>
    @if (baseModal().data.licenseName && baseModal().data.cost) {
      <div>
        <span class="fw-bold">{{ 'shared:common.license' | i18next }}</span>
      </div>
      <div class="mb-3">
        <span>{{ baseModal().data.licenseName }}</span>
      </div>
      <div>
        <span class="fw-bold">{{ 'shared:licenses.cost' | i18next }}</span>
      </div>
      <div class="mb-3">
        <span>{{ baseModal().data.cost | price | async }}</span>
      </div>
    }

    @if (!baseModal().data.isAdminPage && !baseModal().data.isPremiumSupport && !baseModal().data.isDeepInstinct) {
      <div class="mb-3">
        @if (baseModal().data.itemsCount === 1) {
          {{ 'shared:licenses.disableAutoRenewalModal.expireDateHint' | i18next }}
        } @else {
          {{ 'shared:licenses.disableAutoRenewalModal.expireDateHintForManyLicenses' | i18next }}
        }
      </div>
    }
    @if (baseModal().data.isDeepInstinct) {
      <div class="mb-3">
        {{ 'shared:licenses.disableAutoRenewalModal.deepInstHint' | i18next }}
      </div>
    }
    @if (baseModal().data.isPremiumSupport && !baseModal().data.isAdminPage) {
      <div class="mb-3">
        {{ 'shared:licenses.disableAutoRenewalModal.secondHint1' | i18next }}
        <span class="fw-bold">
          {{ formattedReleaseDate() }}
        </span>
        {{ 'shared:licenses.disableAutoRenewalModal.secondHint2' | i18next }}
      </div>
    }
    <div>
      {{
        (baseModal().data.itemsCount === 1
          ? 'shared:licenses.disableAutoRenewalModal.descriptionForOneLicense'
          : 'shared:licenses.disableAutoRenewalModal.description'
        ) | i18next: { count: baseModal().data.itemsCount }
      }}
    </div>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="danger"
      [loading]="loading()"
      (click)="disable()"
      >{{ 'shared:licenses.disableAutoRenewalModal.submit' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()"
      >{{ 'shared:licenses.common.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
